import React, { useEffect, useRef } from 'react';
import { Alert, Space } from 'antd';
import { Button } from '../../../design-system';
import { CHANNEL_LABELS } from './constants';

const ChannelAvailabilityBanner = ({ channelAvailability, onRefresh }) => {
    const setupClickedRef = useRef(false);

    useEffect(() => {
        if (!onRefresh) return undefined;
        const handleFocus = () => {
            if (setupClickedRef.current) {
                setupClickedRef.current = false;
                onRefresh();
            }
        };
        window.addEventListener('focus', handleFocus);
        return () => window.removeEventListener('focus', handleFocus);
    }, [onRefresh]);

    if (!channelAvailability) return null;

    const unavailable = Object.entries(channelAvailability).filter(
        ([, info]) => info && info.available === false,
    );

    if (unavailable.length === 0) return null;

    return (
        <Space direction="vertical" className="notification-preferences__banner-stack">
            {unavailable.map(([channelKey, info]) => {
                const channelLabel = CHANNEL_LABELS[channelKey] || channelKey;
                const description = info.setupHint || info.reason || `${channelLabel} is currently unavailable.`;
                const setupAction = info.setupAction;
                return (
                    <Alert
                        key={channelKey}
                        type="warning"
                        showIcon
                        message={`${channelLabel} delivery isn't set up yet`}
                        description={
                            <div>
                                <div>{description}</div>
                                {setupAction && setupAction.type === 'open_url' && setupAction.url && (
                                    <div className="notification-preferences__banner-actions">
                                        <Button
                                            variant="primary"
                                            size="small"
                                            uppercase={false}
                                            onClick={() => {
                                                setupClickedRef.current = true;
                                                window.open(setupAction.url, '_blank', 'noopener,noreferrer');
                                            }}
                                        >
                                            {setupAction.label || 'Set up'}
                                        </Button>
                                    </div>
                                )}
                            </div>
                        }
                    />
                );
            })}
        </Space>
    );
};

export default ChannelAvailabilityBanner;
